<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="9">
        <v-card height="100%">
          <v-form ref="form">
            <v-card-title> Create Job </v-card-title>
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1"
                  >Choose Job Type</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 2" step="2"
                  >Choose Your Location</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 3" step="3"
                  >Enter Job Details</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step step="4">Advanced Configuration</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card class="mb-5" height="380px">
                    <h3>What kind of job link are you creating?</h3>
                    <v-row v-if="this.mode != 'EDIT'">
                      <v-col cols="6">
                        <v-select
                          v-model="job.jobType"
                          :items="jobTypeList"
                          label="Select Job Type*"
                          :rules="[rules.required]"
                          data-cy="job-form-select-job-type"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col cols="6">
                        <v-select
                          disabled
                          v-model="job.jobType"
                          :items="jobTypeList"
                          label="Select Job Type*"
                          :rules="[rules.required]"
                          data-cy="job-form-select-job-type"
                        />
                      </v-col>
                    </v-row>
                    <div>
                      <h3>What Payroll Provider are you using?</h3>
                      <v-row>
                        <v-col cols="6">
                          <v-select
                            v-model="job.payrollProvider"
                            :items="payrollCompanyList"
                            item-text="name"
                            item-value="id"
                            label="Select Payroll Company*"
                            v-on:change="changePrice"
                            :rules="[rules.required]"
                            data-cy="job-form-select-payroll-company"
                          />
                        </v-col>
                      </v-row>
                    </div>
                    <v-row>
                      <v-col cols="6">
                        <h4>Description:</h4>
                        <p
                          v-if="job.payrollProvider == CAPS_PAYROLL_PROVIDER_ID"
                        >
                          This job type will provide a link that generates Caps
                          cast and crew timecards, as well as a host of other
                          necessary forms (I-9, W-4, Wage Theft, etc..)
                        </p>
                        <p
                          v-else-if="
                            job.payrollProvider ==
                            MEDIA_SERVICES_PAYROLL_PROVIDER_ID
                          "
                        >
                          This job type will provide a link that generates Media
                          Services timecards, as well as a host of other
                          necessary forms (I-9, W-4, Wage Theft, etc..)
                        </p>
                        <p v-else-if="job.jobType == 'Music Video'">
                          This job type will provide a link that generates an
                          Invoice. This invoice calculates total pay, including
                          overtime and meal penalties. It also includes a
                          timecard and w9
                        </p>
                        <p
                          v-else-if="
                            job.payrollProvider ==
                            REVOLUTION_PAYROLL_PROVIDER_ID
                          "
                        >
                          This job type will provide a link that generates
                          Revolution timecards, as well as a host of other
                          necessary forms (I-9, W-4, Wage Theft, etc..)
                        </p>
                        <p
                          v-else-if="
                            job.payrollProvider == STARTING_PAPERWORK_ID
                          "
                        >
                          This job type will provide a link that generates
                          starting paperwork only (I-9, W-4, W-9, Wage Theft,
                          etc..)
                        </p>
                        <p
                          v-else-if="
                            job.payrollProvider == EXTREME_PAYROLL_PROVIDER_ID
                          "
                        >
                          This job type will provide a link that generates
                          Extreme Reach timecards, as well as a host of other
                          necessary forms (I-9, W-4, Wage Theft, etc..)
                        </p>
                      </v-col>
                    </v-row>
                  </v-card>

                  <v-btn color="primary" @click="advance(2)"> Continue </v-btn>

                  <v-btn to="/jobs" text>Cancel</v-btn>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-card class="mb-5" height="300px">
                    <h3>Where are you shooting?</h3>
                    <v-row>
                      <v-col cols="6">
                        <v-select
                          v-model="job.market"
                          :items="marketList"
                          item-text="name"
                          label="Market"
                          item-value="id"
                          :rules="[rules.required]"
                          data-cy="job-form-select-market"
                        />
                      </v-col>
                    </v-row>
                    <h3>When does your shoot end?</h3>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" v-if="this.mode != 'EDIT'">
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="job.endsOn"
                              label="End Date*"
                              :rules="[rules.required]"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="job.endsOn"
                            @input="menu2 = false"
                            :min="new Date().toISOString().substr(0, 10)"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-else>
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              disabled
                              v-model="job.endsOn"
                              label="End Date*"
                              :rules="[rules.required]"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            disabled
                            v-model="job.endsOn"
                            @input="menu2 = false"
                            :min="new Date().toISOString().substr(0, 10)"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-card>

                  <v-btn color="primary" @click="advance(3)"> Continue </v-btn>

                  <v-btn text @click="e1 = 1">Back</v-btn>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-card class="mb-5" height="100%">
                    <h3>Job Details</h3>
                    <v-row>
                      <v-col cols="6" v-if="this.mode != 'EDIT'">
                        <v-text-field
                          v-model="job.name"
                          label="Job Name*"
                          :rules="[rules.required]"
                          data-cy="job-form-text-name"
                        />
                      </v-col>
                      <v-col cols="6" v-else>
                        <v-text-field
                          disabled
                          v-model="job.name"
                          label="Job Name*"
                          :rules="[rules.required]"
                          data-cy="job-form-text-name"
                        />
                      </v-col>
                      <v-col cols="6" v-if="this.mode != 'EDIT'">
                        <v-text-field
                          v-model="job.number"
                          label="Job Number*"
                          :rules="[rules.required]"
                          data-cy="job-form-text-number"
                        />
                      </v-col>
                      <v-col cols="6" v-else>
                        <v-text-field
                          disabled
                          v-model="job.number"
                          label="Job Number*"
                          :rules="[rules.required]"
                          data-cy="job-form-text-number"
                        />
                      </v-col>
                      <v-col cols="6">
                        <CompanySelector
                          v-model="job.company"
                          data-cy="job-form-auto-company"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-btn to="/jobs/request-company">
                          Request Company
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="job.notes"
                          label="Notes for the freelancers"
                          class="pt-0"
                          auto-grow
                          rows="2"
                          data-cy="job-form-text-notes"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="job.supervisorTitle"
                          label="Supervisor Title (Leave as is if unsure)"
                          data-cy="job-form-supervisor-job"
                        />
                      </v-col>
                      <v-col cols="12">
                        <h3>Users</h3>
                      </v-col>
                      <v-col cols="6" v-if="job.payrollProvider != INVOICE_ID">
                        <UserSelector
                          data-cy="job-form-auto-artCoordinator"
                          :value="job.artCoordinator"
                          label="Art Coordinator (Optional)"
                          @input="
                            (user) => {
                              job.artCoordinator = user;
                            }
                          "
                        />
                      </v-col>
                      <v-col v-for="(user, i) in job.users" :key="i" cols="12">
                        <v-row align="center" wrap>
                          <v-col cols="10">
                            <UserSelector
                              :data-cy="`job-form-auto-user-${i}`"
                              :value="user"
                              @input="(user) => updateUser(user, i)"
                              label="Additional Timecard Recipients (Optional)"
                            />
                          </v-col>
                          <v-col cols="2">
                            <v-row wrap>
                              <v-col cols="auto" @click="addUser()">
                                <v-icon :data-cy="`kit-rental-${i}-icon-plus`">
                                  mdi-plus
                                </v-icon>
                              </v-col>
                              <v-col
                                v-if="job.users && job.users.length > 1"
                                cols="auto"
                                @click="removeUser(i)"
                              >
                                <v-icon :data-cy="`kit-rental-${i}-icon-minus`">
                                  mdi-minus
                                </v-icon>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>

                  <v-btn color="primary" @click="advance(4)"> Continue </v-btn>
                  <v-btn text @click="e1 = 2">Back</v-btn>
                </v-stepper-content>

                <v-stepper-content step="4">
                  <v-card class="mb-5" height="100%">
                    <v-row>
                      <v-col cols="6">
                        <h3>Advanced Configuration</h3>
                      </v-col>
                    </v-row>
                    <v-row v-if="job.jobType == 'Music Video' && job.payrollProvider == 3">
                      <v-col
                        v-if="job.jobType == 'Music Video'"
                        cols="12"
                        md="3"
                      >
                        <v-switch
                          v-model="job.removeMealPenalty"
                          label="Remove Meal Penalty"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col cols="6">
                        <v-select
                          v-model="job.timeIncrement"
                          :items="timeIncrementList"
                          hint="Allows Freelancers to select 10 vs 15 minute increments when filling out timecards"
                          persistent-hint
                          label="Select Time Increment"
                          :rules="[rules.required]"
                          data-cy="job-form-select-time-increments"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-row justify="start" align="center">
                          <v-col cols="12" md="3">
                            <v-switch v-model="job.hasTravel" label="Travel" />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-switch
                              v-model="job.hasOutOfZone"
                              label="Out of Zone"
                            />
                          </v-col>
                          <v-col
                            v-if="
                              [
                                CAPS_PAYROLL_PROVIDER_ID,
                                REVOLUTION_PAYROLL_PROVIDER_ID,
                                EXTREME_PAYROLL_PROVIDER_ID,
                              ].includes(job.payrollProvider)
                            "
                            cols="12"
                            md="3"
                          >
                            <v-switch
                              v-model="job.hasEmployeeStartForm"
                              :label="`${getPayrollProviderName(
                                job.payrollProvider
                              )} Start Form`"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-switch
                              v-model="job.isNdaIncluded"
                              label="Include NDAs"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="3"
                            v-if="job.market == CALIFORNIA_MARKET_ID"
                          >
                            <v-switch
                              v-model="job.isDe4Included"
                              label="Include DE-4 California Form"
                            />
                          </v-col>
                          <v-col
                            v-if="job.market == CALIFORNIA_MARKET_ID"
                            cols="12"
                            md="3"
                          >
                            <v-switch
                              v-model="job.hasCaSickLeaveNotice"
                              label="California Paid Sick Leave Notice"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-switch
                              v-model="job.isNonUnion"
                              label="Non Union Job"
                            />
                          </v-col>
                          <!-- <v-col cols="12" md="3">
                            <v-switch
                              v-model="job.hasPrefillMileage"
                              label="Prefill Mileage"
                            />
                          </v-col>
                          <v-col v-if="job.hasPrefillMileage" cols="12" md="3">
                            <v-text-field
                              v-model="job.prefillMileage"
                              label="Mileage Prefill Amount"
                              :rules="[rules.required]"
                              type="number"
                              pattern="\d*"
                              data-cy="job-form-prefill-mileage"
                            />
                          </v-col> -->
                          <v-col
                            v-if="
                              job.payrollProvider ==
                                MEDIA_SERVICES_PAYROLL_PROVIDER_ID ||
                              job.payrollProvider ==
                                REVOLUTION_PAYROLL_PROVIDER_ID ||
                              job.payrollProvider == EXTREME_PAYROLL_PROVIDER_ID
                            "
                            cols="12"
                          >
                            <h3>Shoot Location</h3>
                            <div v-if="job.shoots.length > 0">
                              <v-row>
                                <v-col>
                                  <v-text-field
                                    v-model="job.shoots[0].city"
                                    label="City"
                                    :rules="[rules.required]"
                                    data-cy="job-form-text-number"
                                /></v-col>
                                <v-col>
                                  <v-text-field
                                    v-model="job.shoots[0].county"
                                    label="County"
                                    :rules="[rules.required]"
                                    data-cy="job-form-text-number"
                                /></v-col>
                                <v-col>
                                  <v-text-field
                                    v-model="job.shoots[0].state"
                                    label="State"
                                    :rules="[rules.required]"
                                    data-cy="job-form-text-number"
                                  />
                                </v-col>
                              </v-row>
                            </div>
                            <div v-else>
                              Want to add a shoot location?
                              <v-btn
                                @click="
                                  () =>
                                    job.shoots.push({
                                      city: '',
                                      county: '',
                                      state: '',
                                    })
                                "
                              >
                                Add Shoot Location
                              </v-btn>
                            </div>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-switch
                              v-model="job.showKitRental"
                              label="Include Kit Rental"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-switch
                              v-model="job.showMileageForm"
                              label="Include Mileage Form"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-btn
                    v-if="this.mode === 'EDIT'"
                    color="primary"
                    @click="submit"
                  >
                    Save
                  </v-btn>
                  <v-btn v-else color="primary" @click="submit">
                    To Checkout Page
                  </v-btn>
                  <v-btn text @click="e1 = 3">Back</v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import rules from "../utils/rules";
import { createJob, getJob, updateJob, getJobFromId, changeToHasPaid } from "../services/jobs";
import { getMarkets, CALIFORNIA_MARKET_ID } from "../services/markets";
import UserSelector from "../components/UserSelector.vue";
import CompanySelector from "../components/CompanySelector.vue";
import { DateTime } from "luxon";
import {
  getPayrollProviders,
  MEDIA_SERVICES_PAYROLL_PROVIDER_ID,
  CAPS_PAYROLL_PROVIDER_ID,
  INVOICE_ID,
  REVOLUTION_PAYROLL_PROVIDER_ID,
  EXTREME_PAYROLL_PROVIDER_ID,
  STARTING_PAPERWORK_ID,
  getPayrollProviderName,
} from "../services/payrollProviders";
import { getUser } from "../services/users";

export default {
  components: {
    UserSelector,
    CompanySelector,
  },
  props: {
    mode: {
      type: String,
      default: "EDIT",
    },
  },
  data() {
    return {
      CALIFORNIA_MARKET_ID,
      MEDIA_SERVICES_PAYROLL_PROVIDER_ID,
      CAPS_PAYROLL_PROVIDER_ID,
      INVOICE_ID,
      REVOLUTION_PAYROLL_PROVIDER_ID,
      EXTREME_PAYROLL_PROVIDER_ID,
      STARTING_PAPERWORK_ID,
      payDayFrequency: "",
      payDayFrequencyOther: "",
      job: {
        notes: "",
        manager: {},
        artCoordinator: {},
        users: [
          {
            id: "",
            list: [],
          },
        ],
        endsOn: "",
        jobType: "",
        hasPaid: false,
        isNdaIncluded: false,
        isDe4Incuded: false,
        hasCaSickLeaveNotice: false,
        removeMealPenalty: false,
        isNonUnion: false,
        payrollProvider: "",
        price: "",
        payDay: "",
        supervisorTitle: "Production Supervisor",
        timeIncrement: "15 Minute Increment",
        shoots: [],
        showKitRental: true,
        showMileageForm: true
      },
      rules,
      payDayFrequencyOptions: ["Weekly", "Biweekly", "Other"],
      search: null,
      companyList: [],
      marketList: [],
      payrollCompanyList: [],
      jobTypeList: ["Commercial", "TV", "Music Video", "Live Event"],
      user: {},
      companyAutocompleteIsLoading: false,
      submitButtonIsLoading: false,
      timeIncrementList: [
        {
          text: "10 Minute Increment (1/6ths)",
          value: "10 Minute Increment",
        },
        {
          text: "15 Minute Increment (1/4ths)",
          value: "15 Minute Increment",
        },
        {
          text: "6 Minute Increment (1/10ths)",
          value: "6 Minute Increment",
        },
      ],
      menu2: false,
      e1: 1,
    };
  },
  watch: {
    search: {
      deep: true,
      async handler() {
        await this.updateCompanyList();
      },
    },
  },

  async mounted() {
    if (this.mode === "EDIT") {
      const { data } = await getJob(this.$route.params.jobId);
      this.job = data;
      this.job.market = data?.market?.id;
      this.job.payrollProvider = data?.payrollProvider?.id;
      this.job.endsOn = DateTime.fromISO(this.job.endsOn).toFormat(
        "yyyy-MM-dd"
      );
      if (this.job.users.length === 0) {
        this.job.users = [{ id: "", list: [] }];
      }

      if (this.payDayFrequencyOptions.includes(this.job.payDayFrequency)) {
        this.payDayFrequency = this.job.payDayFrequency;
      }
    }
    const { data } = await getMarkets();
    this.marketList = data?.results;

    let payrollData = await getPayrollProviders();
    this.payrollCompanyList = payrollData["data"]["results"];

    let current_user = await getUser();
    this.user = current_user["data"];

    this.$nextTick(() => {
      this.job = JSON.parse(JSON.stringify(this.job));
    });
  },

  methods: {
    getPayrollProviderName,
    showPayDay() {
      return this.job.market === 3 && this.job.payrollProvider == 1;
    },
    companyText(val) {
      return `${val.name} (${val.manager.email})`;
    },
    async submit() {
      // Freddy's code to validate date
      var theirEndDate = DateTime.fromFormat(
        JSON.parse(JSON.stringify(this.job)).endsOn,
        "yyyy-MM-dd"
      ).toLocal();
      var now = new Date();
      if (theirEndDate == "" || now > theirEndDate) {
        this.$emit("snackbar", {
          text: "Please select a date in the future",
          color: "red",
        });
        return;
      }

      // Checks to see if there are any validation errors
      if (!this.$refs.form.validate()) {
        this.scrollToFirstFormError();
        this.$emit("snackbar", {
          text: "Please fill out all the required fields.",
          color: "red",
        });
        return;
      }

      this.submitButtonIsLoading = true;
      const job = JSON.parse(JSON.stringify(this.job));
      job.users = job.users.map((user) => user?.id).filter((user) => !!user);
      job.manager = this.user["id"];
      job.artCoordinator = job?.artCoordinator?.id || null;
      job.company = job?.company?.id;
      job.endsOn = DateTime.fromFormat(job.endsOn, "yyyy-MM-dd").toLocal();

      if (job.market === 3) {
        job.payDayFrequency =
          this.payDayFrequency === "Other"
            ? this.payDayFrequencyOther
            : this.payDayFrequency;
      }

      let newJobId;
      try {
        console.log('starting process to checkout page');
        if (this.mode === "CREATE") {
          newJobId = await createJob(job);
        } else {
          await updateJob(job);
          this.$router.push({ name: "jobs" });
          return;
        }
        newJobId = newJobId["data"]["id"];

        let jobWithHash = await getJobFromId(newJobId);
        let jobHash = jobWithHash["data"]["hash"];

        if (jobWithHash["data"]["company"]["activeSubscription"]){
          console.log('getting in the if guy!');
          // Marks jobs with companies that have a deal as paid
          await changeToHasPaid(newJobId);
        }

        this.$router.push({ name: "payments.get", params: { hash: jobHash } });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit("snackbar", { text: "502 Bad Gateway", color: "red" });
        } else {
          this.$emit("snackbar", {
            text: "Error Submitting Forms",
            color: "red",
          });
        }
      }
    },
    scrollToFirstFormError() {
      let firstInvalidInput;
      this.$refs.form.inputs.some((input) => {
        if (!input.valid) {
          firstInvalidInput = input;
        }
        return !input.valid;
      });
      if (firstInvalidInput) {
        this.$vuetify.goTo(firstInvalidInput.$el);
      }
    },
    addUser() {
      this.job.users.push({
        id: "",
        list: [],
      });
    },
    updateUser(user, i) {
      this.job.users[i] = user;
    },
    removeUser(index) {
      this.job.users.splice(index, 1);
    },
    changePrice() {
      // Caps Cast and Crew
      if (this.job.payrollProvider == 1) {
        this.job.price = 300;
      }
      // Media Services
      else if (this.job.payrollProvider == 2) {
        this.job.price = 300;
        // Invoices
      } else if (this.job.payrollProvider == 3) {
        this.job.price = 100;
      }
      // Revolution
      else if (this.job.payrollProvider == 4) {
        this.job.price = 300;
      }
      // Starting Paperwork
      else if (this.job.payrollProvider == 5) {
        this.job.price = 300;
      }
      // Extreme Reach
      else if (this.job.payrollProvider == 6) {
        this.job.price = 300;
      }
    },
    checkType() {
      if (this.job.jobType == "Music Video") {
        this.job.payrollProvider = 3;
        this.job.price = 100;
      }
    },
    // nextCard is the card number that the stepper needs to go to
    advance(nextCard) {
      // Checks to see if there are any validation errors
      if (nextCard == 2 && this.job.payrollProvider == "") {
        this.$emit("snackbar", {
          text: "Please fill out all the required fields.",
          color: "red",
        });
        return;
      } else if (nextCard == 3) {
        if (this.job.market == "" || this.job.endsOn == "") {
          this.$emit("snackbar", {
            text: "Please fill out all the required fields.",
            color: "red",
          });
          return;
        }
      } else if (nextCard == 4) {
        if (
          this.job.number == "" ||
          this.job.number == undefined ||
          this.job.name == "" ||
          this.job.name == undefined
        ) {
          this.$emit("snackbar", {
            text: "Please fill out all the required fields.",
            color: "red",
          });
          return;
        }
      }
      this.e1 = nextCard;
    },
  },
};
</script>

<style>
</style>
